__turbopack_context__.v({
  "chatContextDrawer": "_6cXM0G_chatContextDrawer",
  "chatContextDrawer__body": "_6cXM0G_chatContextDrawer__body",
  "chatContextDrawer__closeButton": "_6cXM0G_chatContextDrawer__closeButton",
  "chatContextDrawer__eyebrow": "_6cXM0G_chatContextDrawer__eyebrow",
  "chatContextDrawer__header": "_6cXM0G_chatContextDrawer__header",
  "chatContextDrawer__panel": "_6cXM0G_chatContextDrawer__panel",
});
